export class WarehouseModel{
	bkSubDivisionUidD: number;
	bkWarehouseC: string;
	warehouseN: string;
	warehouseUidK: number;
	warehouseX: string;
	buildingCodeC: string;
}
